import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";
import { Button, ButtonGroup } from "../../../Common";
import BreadCrumb from "../../../Common/BreadCrumb";

const HeaderAuditionInfoSheet = (props: {
  breadCrumbList: any[];
  actor: string;
  t: any;
  onSaveAndClose: () => void;
  onCancelAndClose: () => void;
  pastAudition: boolean;
}) => {
  const {
    breadCrumbList,
    actor,
    t,
    onSaveAndClose,
    onCancelAndClose,
    pastAudition,
  } = props;
  return (
    <Wrapper>
      <HeaderBox>
        <BreadCrumb breadCrumbList={breadCrumbList} />
        <HeaderDetail>
          <Title>{`${actor} ${t("Info sheet")}`}</Title>
          <div className="float-right">
            <ButtonGroup>
              <Button variant="secondary" onClick={onCancelAndClose}>
                {t("Cancel")}
              </Button>
              <Button disabled={pastAudition} onClick={onSaveAndClose}>
                {t("Save & Close")}
              </Button>
            </ButtonGroup>
          </div>
        </HeaderDetail>
      </HeaderBox>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: ${(p) => p.theme.white};
  box-shadow: inset 0 -1px 0 0 #e7e7f0;
`;

const HeaderBox = styled.div`
  height: 95px;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  justify-content: start;

  padding: 16px 0;
  margin: 0 auto;
`;

const HeaderDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 16px;
`;

const Title = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["xxl-font-size"]};
  font-weight: ${(p) => p.theme["font-weight"]};
  line-height: 28px;
`;

export default withI18n()(HeaderAuditionInfoSheet);
